export enum RequestType {
  get = "GET",
  post = "POST",
  put = "PUT",
  delete = "DELETE",
}
